<pbc-filter-preset
  [filter]="projekte.preset$ | async"
  [filters]="projekte.presets$ | async"
  [name]="projekte.search$ | async"
  (select)="projekte.setFilter($event)"
  (save)="projekte.writeFilter($event)"
  (delete)="projekte.deleteFilter($event)"
></pbc-filter-preset>
